import React, { FC } from 'react'
import { getBasicPageMetaData, Seo } from '@/layout/Seo'
import { useLocale } from '@/utils/LocaleUtil'
import { useTranslate } from '@/utils/translate/translate-client'
import { useGiveawayContext } from '../../context/GiveawayContext'

export const GiveawaySeo: FC = () => {
  const { sweepstake, theatricalSlug } = useGiveawayContext()
  const { locale } = useLocale()
  const { t } = useTranslate('tickets')

  const { seoImageUrl, projectName } = sweepstake

  return (
    <Seo
      {...getBasicPageMetaData({
        cloudinaryImagePath: seoImageUrl ?? '',
        cloudinaryTransformation: 'b_rgb:000000,c_fill',
        title: t('giveawaySeoTitleAngel', 'PRE-ORDER {{projectName}} Tickets | Angel', {
          projectName,
        }),
        description: t('giveawaySeoDescription', 'Buy {{projectName}} tickets for a Chance to Win the Giveaway!', {
          projectName,
        }),
        locale,
        path: `/giveaway/${theatricalSlug}`,
      })}
    />
  )
}
